import { useContext } from "react";
import { Handle, Position } from "reactflow";
import { Tooltip, Checkbox, FormControlLabel } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import LinkIcon from "@mui/icons-material/Link";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import NodeDeleteContext from "./NodeDeleteContext";
import { useDispatch, useSelector } from "react-redux";
import { saveGame } from "../../redux/asyncThunk/userActions";
import { stripSchemeTransient } from "./schemeLayout";
import { isTrainerGame } from "../../utils/contentType";

const ButtonNode = (props) => {
  const { selected, data, id } = props;

  const { onNodesDelete, edges, nodes, onCreateSceneFromButton } =
    useContext(NodeDeleteContext);
  const dispatch = useDispatch();
  const selectedGameId = useSelector((state) => state.user?.selectedGameId);
  const game = useSelector((state) => state.user?.game);
  const isTrainer = isTrainerGame(game);

  const hasOutgoingEdge = edges?.some((edge) => edge.source === id);

  const handleDelete = (event) => {
    event.stopPropagation();
    onNodesDelete([props]);
  };

  const handleCorrectToggle = (event) => {
    event.stopPropagation();
    const isCorrect = event.target.checked;
    const updatedNodes = (nodes ?? []).map((node) =>
      node.id === id
        ? {
            ...node,
            data: {
              ...node.data,
              isCorrect,
            },
          }
        : node
    );

    dispatch(
      saveGame({
        selectedGameId,
        nodes: stripSchemeTransient(updatedNodes),
        edges: edges ?? [],
      })
    );
  };

  const handleAddScene = (event) => {
    event.stopPropagation();
    onCreateSceneFromButton?.(id);
  };

  const label = data?.label || "";

  return (
    <div className="scheme-button-wrap">
      <div
        className={`scheme-button__pill${
          isTrainer && data?.isCorrect ? " scheme-button__pill--correct" : ""
        }`}
      >
        {selected && (
          <DeleteIcon
            className="scheme-button-delete nodrag nopan"
            fontSize="inherit"
            onPointerDown={(event) => event.stopPropagation()}
            onClick={handleDelete}
          />
        )}
        <Tooltip title={label} placement="top" enterDelay={400}>
          <span className="scheme-button__label nodrag nopan">{label}</span>
        </Tooltip>
        {isTrainer && selected ? (
          <FormControlLabel
            className="scheme-button__correct nodrag nopan"
            control={
              <Checkbox
                size="small"
                checked={Boolean(data?.isCorrect)}
                onChange={handleCorrectToggle}
              />
            }
            label="Верно"
          />
        ) : null}
        {hasOutgoingEdge ? (
          <Tooltip title="Кнопка связана со сценой" placement="top">
            <span className="scheme-button__linked nodrag nopan">
              <CheckCircleOutlineIcon fontSize="inherit" />
            </span>
          </Tooltip>
        ) : (
          <>
            <Tooltip title="Создать новую сцену и сразу связать с кнопкой" placement="top">
              <button
                type="button"
                className="scheme-button__add-scene nodrag nopan"
                onClick={handleAddScene}
              >
                <AddIcon fontSize="inherit" />
                <span>Сцена</span>
              </button>
            </Tooltip>
            <Tooltip title="Потяните к уже существующей сцене слева" placement="top">
              <span className="scheme-button__link">
                <LinkIcon fontSize="inherit" className="scheme-button__link-icon" />
                <Handle
                  type="source"
                  position={Position.Right}
                  id="source"
                  className="scheme-button__handle"
                  isConnectable
                />
              </span>
            </Tooltip>
          </>
        )}
      </div>
    </div>
  );
};

export default ButtonNode;
